module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAABPUlEQVRIS+WUPU4CURSFPxIWQEHsIJHQGFp1E/5sAXULGCp2gK4BXIO4CkJBpZ2hJtZamEhOMpOQ8b03b+6MRMJt5577zb0579TYcdV2zONwgRfAFGgaT74GboGXrN53UgmssJShGUf/FjgG7o3nTGWaMYzdsAu8AnUj9Ac4BlaxQPU9A5dGoLTXLm3oHcqpMwNQ2125HKpZIaDOqbPqvEXqHej4BHlJMwAeitASsz1agQ1A7ynWPJ9AC/iwAqWbADeRW6r3LtSbd1JpT4F5BFBmOQMWZYHSCyhwqNRznvdjMRtqRj8J89A8nf2pKqBMI/PIRK7StzbwVRVQc0L56szNokmT7fflqzc3ywKld+WrNzerAGbzNZibVQCz+foGnOQZZft77LPY1vSSfP0GRsDyr4FF5v/qtWy4X8AN5tMzHRHX2rQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/down.png
// module id = w80D
// module chunks = 1